export enum SocketEvents {
	TILE_DATA			= "TILE_DATA",
	TILE_UPDATE   = "TILE_UPDATE",
	ADD_SEED			= "ADD_SEED",
	SEEDS_DATA		= "SEEDS_DATA",
}